import GsDialog from "./gs-dialog.vue"
const component = {
  install: (Vue) => {
    Vue.component('GsDialog', GsDialog)
  }
}
export default component